import { authorize, deleteRequest } from '../../../utils/http';
import { AWS_API_URL } from '../../../global/environment';

export async function deletePairingAPI(userEmail) {
  const url = `${AWS_API_URL}/2n/users/${userEmail}/mobile-key`;

  return deleteRequest(url, await authorize());
}
